// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"7307761c","688":"dde0f656","814":"7e7f6627"}[chunkId] + ".chunk.css";
};